package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.viewModel.LetterViewModel
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.di.koinGet
import io.horion.cv.styles.PersonalFormFullWidthStyle
import io.horion.cv.styles.PersonalFormGroupColumnStyle
import io.horion.cv.styles.PersonalFormHalfWidthStyle
import io.horion.cv.styles.PersonalFormMainColumnStyle
import io.horion.cv.styles.PersonalFormRowStyle
import org.jetbrains.compose.web.css.px
@OptIn(DelicateApi::class)
@Composable
fun PersonalFormWithoutDetails() {
    val letterViewModel = koinGet<LetterViewModel>()
    val letterUiState = letterViewModel.letterUiState
    val pi = letterUiState.data.personalInformation

    Column(
        modifier = PersonalFormMainColumnStyle.toModifier()
    ) {
        Column(
            modifier = PersonalFormGroupColumnStyle.toModifier()
        ) {
            // Prénom & Nom (Côte à côte en Desktop, empilés en Mobile)
            Row(
                modifier = PersonalFormRowStyle.toModifier()
            ) {
                TextFormField(
                    label = "Prénom(s)",
                    value = pi.lastName,
                    onValueChange = { value ->
                        letterViewModel.updatePersonalInfo { it.copy(lastName = value) }
                    },
                    modifier = PersonalFormHalfWidthStyle.toModifier(),
                    inputId = "input-lastName"
                )

                TextFormField(
                    label = "Nom(s) de famille",
                    value = pi.firstName,
                    onValueChange = { value ->
                        letterViewModel.updatePersonalInfo { it.copy(firstName = value) }
                    },
                    modifier = PersonalFormHalfWidthStyle.toModifier(),
                    inputId = "input-firstName"
                )
            }

            // Email (Pleine largeur)
            TextFormField(
                label = "Adresse e-mail",
                value = pi.email,
                onValueChange = { value ->
                    letterViewModel.updatePersonalInfo { it.copy(email = value) }
                },
                modifier = PersonalFormFullWidthStyle.toModifier(),
                inputId = "input-email"
            )
        }

        // Adresse & Téléphone
        Row(
            modifier = PersonalFormRowStyle.toModifier()
        ) {
            TextFormField(
                label = "Adresse",
                value = pi.address,
                onValueChange = { value ->
                    letterViewModel.updatePersonalInfo { it.copy(address = value) }
                },
                modifier = PersonalFormHalfWidthStyle.toModifier(),
                inputId = "adresse"
            )

            TextFormField(
                label = "Numéro de téléphone",
                value = pi.phone,
                onValueChange = { value ->
                    letterViewModel.updatePersonalInfo { it.copy(phone = value) }
                },
                modifier = PersonalFormHalfWidthStyle.toModifier(),
                inputId = "input-phone"
            )
        }

        // Pays
        TextFormField(
            label = "Pays",
            value = pi.country,
            onValueChange = { value ->
                letterViewModel.updatePersonalInfo { it.copy(country = value) }
            },
            modifier = PersonalFormFullWidthStyle.toModifier(),
            inputId = "country"
        )

        // Code Postal & Ville
        Row(
            modifier = PersonalFormRowStyle.toModifier()
        ) {
            TextFormField(
                label = "Code Postal",
                value = pi.bp,
                onValueChange = { value ->
                    letterViewModel.updatePersonalInfo { it.copy(bp = value) }
                },
                modifier = PersonalFormHalfWidthStyle.toModifier()
            )

            TextFormField(
                label = "Ville",
                value = pi.city,
                onValueChange = { value ->
                    letterViewModel.updatePersonalInfo { it.copy(city = value) }
                },
                modifier = PersonalFormHalfWidthStyle.toModifier(),
                inputId = "ville"
            )
        }
    }
}